export default __webpack_public_path__ + "static/media/kenia.bdf55caf.pdf";